import React from 'react'
import Header from './Header'
import ProductPageFooter from './ProductPageFooter'
import IgniteAIBody from './IgniteAIBody'

const IgniteAIProject = () => {
    return (
        <>
            <Header />
            <IgniteAIBody />
            <ProductPageFooter />
        </>
    )
}

export default IgniteAIProject
